import "../../../../styles/productViewListItem.scss";

import Icon, {iconTypes} from "../../../common/components/Icon.jsx";
import { canWorkWithOrder, getProductOrderProperty} from "../../util/orderUtil.js";
import { claimCodeOptions, claimCodes } from "../../util/claimCodes.js";
import { countAddedSalesUnits, countAddedWarehouseUnits } from "../../util/historyUtil";

import CheckBox from "../../../common/components/CheckBox";
import CounterField from "../../../common/components/CounterField.jsx";
import DropDownList from "../../../common/components/DropDownList.jsx";
import LabelField from "../../../common/components/LabelField.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import ProductViewModal from "../product/ProductViewModal.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn";
import ResponsiveRows from "../../../common/components/ResponsiveRows";

export class ProductClaimListHeader extends React.PureComponent {
    render(){
        const {
            deviceType,
            localization,
        } = this.props;

        switch(deviceType) {
        case "xs":
            return (
                <div style={{marginTop:"8px", marginBottom:"8px"}}>
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={8}>
                            <div className="product-view-list-header" style={{textIndent:"70px"}}>
                                {localization.text("order","view","product")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={4}>
                            <div className="product-view-list-header" style={{width:"100%",textAlign:"right"}}>
                                {localization.text("order","view","inTheOrder")}
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            );
        default:
            return (
                <div style={{marginTop:"8px", marginBottom:"8px"}}>
                    <ResponsiveRows gutters={false}>
                        <ResponsiveColumn xs={9}>
                            <div className="product-view-list-header" style={{textIndent:"70px"}}>
                                {localization.text("order","view","product")}
                            </div>
                        </ResponsiveColumn>
                        <ResponsiveColumn xs={3}>
                            <div className="product-view-list-header" style={{width:"100%",textAlign:"right"}}>
                                {localization.text("order","view","inTheOrder")}
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                </div>
            );
        }
    }
}

ProductClaimListHeader.propTypes = {
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
};

export class ProductClaimListItem extends React.PureComponent {
    constructor(props){
        super(props);

        this.state = {
            counter: 0,
        };

        this.changeSalesUnit = this.changeSalesUnit.bind(this);
        this.changeWarehouseUnit = this.changeWarehouseUnit.bind(this);
        this.showProductModal = this.showProductModal.bind(this);
        this.closeProductModal = this.closeProductModal.bind(this);
        this.onClaimReason = this.onClaimReason.bind(this);
        this.onReturnGoods = this.onReturnGoods.bind(this);
    }
    changeSalesUnit(change) {
        const {
            addRemoveSalesUnitToClaim,
            product,
        } = this.props;

        addRemoveSalesUnitToClaim(product, change.value);
    }
    changeWarehouseUnit(change) {
        const {
            addRemoveWarehouseUnitToClaim,
            product,
        } = this.props;

        addRemoveWarehouseUnitToClaim(product, change.value);
    }
    onClaimReason(change){
        if( change.reasonCode===claimCodes.missingGoods){
            change.returnGoods = false;
        } else if( change.reasonCode===claimCodes.pickError){
            change.returnGoods = true;
        } else if( change.reasonCode===claimCodes.pickErrorCustomerKeep){
            change.returnGoods = false;
        }
        this.props.editClaimItem(this.props.product.productId, change);
    }
    onReturnGoods(change){
        this.props.editClaimItem(this.props.product.productId, change);
    }
    showProductModal(event) {
        event.stopPropagation();
        event.preventDefault();

        const {
            localization,
            product,
            list,
        } = this.props;

        this.props.setModal(<ProductViewModal localization={localization} product={product} activeOrder={list} onAddProductChange={this.changeWarehouseUnit} onCloseModal={this.closeProductModal} width={460}/>);
    }
    closeProductModal(event) {
        event.stopPropagation();
        event.preventDefault();
        
        this.props.setModal(null);
    }
    render(){
        const {
            deviceType,
            disabled,
            localization,
            product,
            list,
            claimItem,
            border,
            setDropDown,
        } = this.props;

        const warehouseUnits = countAddedWarehouseUnits(list, product.productId);
        const salesUnits = countAddedSalesUnits(list, product.productId);
        const canEdit = canWorkWithOrder(list) && !disabled;
        const minValue = getProductOrderProperty(list, product.productId, "mustOrderAtLeastOne")?1:0;
        const canNotEditReturnGoods = claimItem.reasonCode==null || claimItem.reasonCode==claimCodes.missingGoods || claimItem.reasonCode==claimCodes.pickError || claimItem.reasonCode==claimCodes.pickErrorCustomerKeep;

        switch(deviceType) {
        case "xs":
            return (
                <div className="product-view-list-item-wrapper" draggable={false}>
                    <div className="container">
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={7.8}>
                                <div className="product-view-list-item-tiny">
                                    <div className={"product-view-list-item-image-background"}  onClick={this.showProductModal}>
                                        {product.imageUrl && (
                                            <React.Fragment>
                                                <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                                {minValue===1 && (
                                                    <Icon type={iconTypes.lockOneLocked} className="lock"/>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div style={{flexGrow:"1"}}>
                                        <div className="label14 prd-name"  onClick={this.showProductModal}>
                                            {product.productName}
                                        </div>
                                        <div className="prd-info">
                                            <div className="label10 prd-size">
                                                {localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1.2}>
                                <div className="product-view-list-item-vertical">
                                    <div className="label10">
                                        {localization.text("history","warehouseUnits")}
                                    </div>   
                                    <div className="label10">
                                        {localization.text("history","salesUnits")}
                                    </div>      
                                </div>                                
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={3}>                                
                                <div className="product-view-list-item-counter-field" style={{marginTop:"-5px"}}>
                                    <CounterField onEdit={this.changeWarehouseUnit} value={warehouseUnits} version={list.version || undefined} border={border} small={false} disabled={!canEdit} minValue={minValue} alwaysShowInputField={true}/>
                                </div>                                
                                <div className="product-view-list-item-counter-field" style={{marginTop:"-18px"}}>
                                    <CounterField onEdit={this.changeSalesUnit} value={salesUnits} version={list.version || undefined} border={border} small={true} disabled={!canEdit} minValue={minValue} alwaysShowInputField={true}/>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <LabelField label={localization.text("history","reasonCode")} isRequired={true} />
                                <DropDownList options={claimCodeOptions} onEdit={this.onClaimReason} source={claimItem} placeholder={localization.text("history","selectReason")} property={"reasonCode"} setDropDown={setDropDown} />
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <LabelField label={localization.text("history","returnGoodsLabel")} isRequired={true} />
                                {<div className="checkbox-column">
                                    <CheckBox disabled={canNotEditReturnGoods} property={"returnGoods"} source={claimItem} label="" onChange={this.onReturnGoods} />
                                </div>}
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            );
        default:
            return (
                <div className="product-view-list-item-wrapper not-interactive" draggable={false}>
                    <div className="container">
                        {this.state.showModal && (
                            <ProductViewModal localization={localization} product={product} activeOrder={list} onAddProductChange={this.changeWarehouseUnit} onCloseModal={this.closeProductModal} width={460}/>
                        )}
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={8}>
                                <div className="product-view-list-item-tiny">
                                    <div className={"product-view-list-item-image-background"} onClick={this.showProductModal}>
                                        {product.imageUrl && (
                                            <React.Fragment>
                                                <img src={product.imageUrl} className={"product-view-list-item-image"} />
                                                {minValue===1 && (
                                                    <Icon type={iconTypes.lockOneLocked} className="lock"/>
                                                )}
                                            </React.Fragment>
                                        )}
                                    </div>
                                    <div style={{flexGrow:"1"}}>
                                        <div className="label14 prd-name" onClick={this.showProductModal}>
                                            {product.productName}
                                        </div>
                                        <div className="prd-info">
                                            <div className="label10 prd-size">
                                                {localization.text("order","packSize",{noOfSalesUnits:product.noOfSalesUnits})}
                                            </div>
                                            
                                        </div>
                                        
                                    </div>
                                </div>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={1}>
                                <div className="product-view-list-item-vertical">
                                    <div className="label10">
                                        {localization.text("history","warehouseUnits")}
                                    </div>   
                                    <div className="label10">
                                        {localization.text("history","salesUnits")}
                                    </div>      
                                </div>                                
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={3}>    
                                <ResponsiveRows gutters={false}>
                                    <ResponsiveColumn className="product-view-list-item-counter-field" xs={12}>
                                        <CounterField className="input-counterField-wrapper-claim" onEdit={this.changeWarehouseUnit} value={warehouseUnits} version={list.version || undefined} border={border} small={true} disabled={!canEdit} minValue={minValue} alwaysShowInputField={true}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn  className="product-view-list-item-counter-field" xs={12}>
                                        <CounterField className="input-counterField-wrapper-claim" onEdit={this.changeSalesUnit} value={salesUnits} version={list.version || undefined} border={border} small={true} disabled={!canEdit} minValue={minValue} alwaysShowInputField={true}/>
                                    </ResponsiveColumn>
                                </ResponsiveRows> 
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <ResponsiveRows>
                                    <ResponsiveColumn xs={8}>
                                        <LabelField label={localization.text("history","reasonCode")} isRequired={false} />
                                        <DropDownList options={claimCodeOptions} onEdit={this.onClaimReason} source={claimItem} placeholder={localization.text("history","selectReason")} property={"reasonCode"} setDropDown={setDropDown}/>
                                    </ResponsiveColumn>
                                    <ResponsiveColumn xs={4}>
                                        <LabelField label={localization.text("history","returnGoodsLabel")} isRequired={false} />                                            
                                        {<div className="checkbox-column" style={{marginLeft: "Auto"}} >
                                            <CheckBox disabled={canNotEditReturnGoods} property={"returnGoods"} source={claimItem} label="" onChange={this.onReturnGoods} />
                                        </div>}                                
                                    </ResponsiveColumn>
                                </ResponsiveRows>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </div>
                </div>
            );
        }
    }
}

ProductClaimListItem.propTypes = {
    addRemoveSalesUnitToClaim: PropTypes.func.isRequired,
    addRemoveWarehouseUnitToClaim: PropTypes.func.isRequired,
    editClaimItem: PropTypes.func.isRequired,
    list: PropTypes.object.isRequired,
    claimItem: PropTypes.object.isRequired,
    deviceType: PropTypes.string.isRequired,
    localization: Localization.propTypes.isRequired,
    setModal: PropTypes.func.isRequired,
    setDropDown: PropTypes.func.isRequired,
    product: PropTypes.object,
    border: PropTypes.bool,
    //If we should not use a counter
    disabled: PropTypes.bool,
};

ProductClaimListItem.defaultProps = {
    disabled: false,
};